import { SelectItem, FieldItem, DomainNode, FieldValue, SelectionTypeResult } from '../../types';
import { SelectionTypeItem, SelectionValue, SelectionType } from './types-fields';
import { defaultIntervalValue } from 'app/area/reports/constants';

const generateLevelOptions = (maxLevel: number, textLevel: string, additionalLevel?: SelectItem) => {
  const result: SelectItem[] = [];
  if (!!additionalLevel) {
    result.push(additionalLevel);
  }
  for (let index = 1; index <= maxLevel; index++) {
    result.push({ value: index, description: `${textLevel} ${index}` });
  }
  return result;
};

export const domainNodeToComplexType = (dn: DomainNode): FieldItem => {
  return {
    value: dn.domain,
    description: dn.label,
    descendants: !!dn.children ? dn.children.map(domainNodeToComplexType) : undefined
  };
};
export const fieldValueToComplexType = (dn: FieldValue): SelectItem => {
  return {
    value: dn.v,
    description: dn.d,
    allowRollingAverage: dn.allowRollingAverage,
    rollingAverageDescription: dn.uom,
    descendants: !!dn.children ? dn.children.map(fieldValueToComplexType) : undefined
  } as SelectItem;
};

export const mapSelectionType = (dn: SelectionTypeResult, textLevel: string, additionalLevel?: SelectItem): SelectionTypeItem => {
  return {
    type: dn.type.v,
    label: dn.type.d,
    levels: !!dn.maxLevels ? generateLevelOptions(dn.maxLevels, textLevel, additionalLevel) : undefined,
    categories: !!dn.categories ? dn.categories.map(fieldValueToComplexType) : undefined,
    periods: !!dn.periods ? dn.periods.map(fieldValueToComplexType) : undefined,
    defaultSelected: dn.defaultSelected
  };
};

export const setDefaultValue = (selections: SelectionTypeItem[]): SelectionValue => {
  const defaultSelection = selections.find(s => s.defaultSelected);

  if (!defaultSelection) {
    return {
      type: selections[0].type
    };
  }

  return {
    type: defaultSelection.type,
    period: defaultSelection.periods && !!defaultSelection.periods.length && defaultSelection.periods[0],
    level: defaultSelection.levels && defaultSelection.levels.length ? defaultSelection.levels[0] : undefined,
    category: defaultSelection.categories && defaultSelection.categories.length ? defaultSelection.categories[0] : undefined,
    interval: defaultSelection.type===SelectionType.Interval ? defaultIntervalValue : undefined
  };
};
